var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit, Watch } from "vue-property-decorator";
import { Dependencies } from '~/core/decorator';
import { CaseOperatorPageService } from '~/services/domain-service/case-operator-page.service.ts';
import { State, namespace } from "vuex-class";
import { MENU_CHANNEL } from "~/config/enum.config";
var CollectionExecutionModule = namespace('collection-execution');
var FilingStep = /** @class */ (function (_super) {
    __extends(FilingStep, _super);
    function FilingStep() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            legalStatus: "REGISTER",
            id: "",
            legalHandleType: "",
            plaintiffInformation: "",
            personalName: "",
            idCard: "",
            courtName: "",
            indexNumber: "",
            isSafe: "",
            safeAmount: "",
            lawsuitFee: "",
            noticeFee: "",
            belongName: "",
            legalArchivesNo: "",
            legalArchivesPlace: "",
            legalCaseNo: "",
            legalCasePlace: "",
            registerRemark: "",
            lawsuitAmount: "",
        };
        //数据校验
        _this.rules = {
            legalHandleType: [{ required: true, message: "请选择处理方式" }],
            plaintiffInformation: [{ required: true, message: "请选择原告信息" }],
            personalName: [{ required: true, message: "请输入被告人姓名" }],
            idCard: [{ required: true, message: "请输入身份证号" }],
            courtName: [{ required: true, message: "请输入法院/仲裁委" }],
        };
        _this.submitLoading = false;
        return _this;
    }
    Object.defineProperty(FilingStep.prototype, "isShow", {
        get: function () {
            var _this = this;
            var arr = [MENU_CHANNEL.Legal_personal, MENU_CHANNEL.Legal_team, MENU_CHANNEL.Assist_legal];
            if (arr.find(function (v) { return _this.menuChannel === v; })) {
                // 添加催记显示保存按钮 或编辑催记 与该登录用户一致显示
                if (!this.operatorId || this.operatorId === this.userData.id)
                    return true;
                else
                    return false;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    FilingStep.prototype.nextStepEmit = function () { };
    FilingStep.prototype.finishCaseEmit = function () { };
    FilingStep.prototype.emitSuccess = function () {
        if (this.id) {
            this.showLegalInfoById(this.id);
        }
        else {
            // this.showLegalInfo();
        }
    };
    FilingStep.prototype.showPersonalName = function (val) {
        if (this.caseId && !this.id) {
            this.formData.personalName = val.personalName;
            this.formData.idCard = val.idCard;
        }
    };
    FilingStep.prototype.showLegalInfoById = function (val) {
        var _this = this;
        this.caseOperatorPageService
            .queryCaseLegalRecordById(val)
            .subscribe(function (data) {
            if (data) {
                _this.formData.id = data.id;
                _this.formData.legalHandleType = data.legalHandleType;
                _this.formData.plaintiffInformation = data.plaintiffInformation;
                _this.formData.personalName = data.personalName;
                _this.formData.idCard = data.idCard;
                _this.formData.courtName = data.courtName;
                _this.formData.indexNumber = data.indexNumber;
                _this.formData.isSafe = data.isSafe;
                _this.formData.safeAmount = data.safeAmount;
                _this.formData.lawsuitFee = data.lawsuitFee;
                _this.formData.noticeFee = data.noticeFee;
                _this.formData.belongName = data.belongName;
                _this.formData.legalArchivesNo = data.legalArchivesNo;
                _this.formData.legalArchivesPlace = data.legalArchivesPlace;
                _this.formData.legalCaseNo = data.legalCaseNo;
                _this.formData.legalCasePlace = data.legalCasePlace;
                _this.formData.registerRemark = data.registerRemark;
                _this.formData.lawsuitAmount = data.lawsuitAmount;
            }
        }, function (err) {
        });
    };
    FilingStep.prototype.mounted = function () {
        if (this.id) {
            this.showLegalInfoById(this.id);
        }
        else {
            this.formData.belongName = this.userData.realName;
            this.formData.personalName = this.topInfo.personalName;
            this.formData.idCard = this.topInfo.idCard;
            // this.showLegalInfo();
        }
    };
    FilingStep.prototype.showLegalInfo = function () {
        var _this = this;
        //查询上一条催记是否结案，回显数据
        this.caseOperatorPageService
            .queryUnClossCaseLegalRecord(this.caseId)
            .subscribe(function (data) {
            if (data) {
                _this.formData.id = data.id;
                _this.formData.legalHandleType = data.legalHandleType;
                _this.formData.plaintiffInformation = data.plaintiffInformation;
                if (data.isRegister === "YES") {
                    _this.formData.personalName = data.personalName;
                    _this.formData.idCard = data.idCard;
                    _this.formData.courtName = data.courtName;
                    _this.formData.belongName = data.belongName;
                }
                _this.formData.indexNumber = data.indexNumber;
                _this.formData.isSafe = data.isSafe;
                _this.formData.safeAmount = data.safeAmount;
                _this.formData.lawsuitFee = data.lawsuitFee;
                _this.formData.noticeFee = data.noticeFee;
                _this.formData.legalArchivesNo = data.legalArchivesNo;
                _this.formData.legalArchivesPlace = data.legalArchivesPlace;
                _this.formData.legalCaseNo = data.legalCaseNo;
                _this.formData.legalCasePlace = data.legalCasePlace;
                _this.formData.registerRemark = data.registerRemark;
                _this.formData.lawsuitAmount = data.lawsuitAmount;
            }
        }, function (err) {
        });
    };
    FilingStep.prototype.addRecord = function () {
        this.id = "";
        this.submit();
    };
    FilingStep.prototype.submit = function () {
        var _this = this;
        var form = this.$refs["filing-step-form"];
        form.validate(function (valid) {
            if (!valid)
                return false;
            if (_this.menuChannel === MENU_CHANNEL.Assist_legal) {
                _this.formData.assistId = _this.otherData.assistId;
            }
            if (_this.formData.isSafe === "") {
                _this.formData.isSafe = null;
            }
            _this.formData.caseId = _this.caseId;
            _this.caseOperatorPageService
                .addCaseLegalRecord(_this.formData)
                .subscribe(function (data) {
                form.resetFields();
                _this.formData.id = "";
                _this.emitSuccess();
                _this.$message.success('法催催记立案已添加成功，如需修改请在法务详情中进行修改');
            }, function (err) {
                _this.submitLoading = false;
            });
        });
    };
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], FilingStep.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], FilingStep.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], FilingStep.prototype, "menuChannel", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], FilingStep.prototype, "otherData", void 0);
    __decorate([
        Prop({ type: String, required: false })
    ], FilingStep.prototype, "id", void 0);
    __decorate([
        Prop()
    ], FilingStep.prototype, "topInfo", void 0);
    __decorate([
        Prop({ type: String })
    ], FilingStep.prototype, "operatorId", void 0);
    __decorate([
        State
    ], FilingStep.prototype, "userData", void 0);
    __decorate([
        Emit('nextStep')
    ], FilingStep.prototype, "nextStepEmit", null);
    __decorate([
        Emit('finishCase')
    ], FilingStep.prototype, "finishCaseEmit", null);
    __decorate([
        Emit('emitSuccess')
    ], FilingStep.prototype, "emitSuccess", null);
    __decorate([
        Watch('topInfo')
    ], FilingStep.prototype, "showPersonalName", null);
    FilingStep = __decorate([
        Component({
            components: {}
        })
    ], FilingStep);
    return FilingStep;
}(Vue));
export default FilingStep;
